import { Box, Collapse } from '@mui/material';

/**
 * v4 desktop inline category expansion (#1377, DESIGN_SYSTEM.md 8.8 + board).
 * A category's rows render IN PLACE beneath their row, on a recessed
 * sub-surface (overlay color-mixed toward the page) between top and bottom
 * hairlines. Rows inside stay MenuItems; the wrapper is presentation so
 * MUI MenuList arrow navigation skips it. `depth` indents nested expansions
 * (the Help panel's "Available guides" accordion).
 *
 * @param {object} props
 * @param {string} [props.id]        region id (aria-controls target)
 * @param {boolean} props.open
 * @param {string} [props.label]     accessible group label
 * @param {number} [props.depth]     nesting level (0 = category, 1 = accordion)
 * @param {('li'|'div')} [props.component]  wrapper element; use 'div' when
 *                                    already inside another InlineCategory
 * @param {React.ReactNode} props.children
 */
export default function InlineCategory({
  id,
  open,
  label,
  depth = 0,
  component = 'li',
  children,
}) {
  return (
    <Box component={component} role="presentation" sx={{ padding: 0, margin: 0, listStyle: 'none' }}>
      <Collapse in={open} unmountOnExit timeout={150}>
        <Box
          id={id}
          role="group"
          aria-label={label}
          sx={(theme) => ({
            background: `color-mix(in srgb, ${theme.palette.surface.overlay} ${78 + depth * 4}%, ${theme.palette.surface.page})`,
            borderTop: `1px solid ${theme.palette.divider}`,
            borderBottom: `1px solid ${theme.palette.divider}`,
            padding: '2px 0',
            '& > .MuiMenuItem-root, & > li > .MuiMenuItem-root': {
              paddingLeft: `${46 + depth * 16}px`,
              paddingTop: '9px',
              paddingBottom: '9px',
              fontSize: '13px',
            },
          })}
        >
          {children}
        </Box>
      </Collapse>
    </Box>
  );
}
